import { Typography } from '@design-system/components/typography/typography';
import { space } from '@design-system/tokens';
import { Gap } from '@design-system/components/grid/grid';
import shortImage from '../assets/short.png';
import longImage from '../assets/long.png';
import {
  noVideosContent,
  noVideosWrapper,
  videoCard,
  videoCardWrapper,
} from './NoVideos.css';
import { sprinkles } from '@design-system/sprinkles.css';
import { VideoModal } from '@design-system/components/modal/videoModal';
import { useState } from 'react';
import { LibraryVM } from '../view-models/library.viewModel';
import { Button } from '@design-system/components/button/button';
import { faPlus } from '@fortawesome/pro-solid-svg-icons';
import { FlowEducationalModal } from '@client/new/common/onboardingFlow/FlowEducationalModal';
import { faFileArrowUp } from '@fortawesome/pro-regular-svg-icons';

const VideoCard = (p: {
  title: string;
  desc: string;
  imgUrl: string;
  exampleUrl: string;
  onClick: () => void;
}) => {
  const handleOpen = () => {
    setOpen(true);
    p.onClick();
  };

  const [open, setOpen] = useState(false);
  return (
    <div className={videoCard}>
      <div>
        <div className="h-[140px]">
          <Typography variant="title" size="large">
            {p.title}
          </Typography>
          <Gap height="l" />
          <Typography variant="body" size="medium">
            {p.desc}
          </Typography>
          <Gap height="l" />
        </div>
        <Typography variant="body" size="medium">
          <div className="cursor-pointer" onClick={handleOpen}>
            <Typography
              variant="body"
              size="large"
              className={sprinkles({ color: 'P-80', fontWeight: 'extraBold' })}
            >
              Watch example
            </Typography>
          </div>
        </Typography>
      </div>
      <div
        style={{
          flex: '0 0 105px',
          marginTop: '-' + space['m'],
          display: 'flex',
          justifyContent: 'center',
        }}
      >
        <img src={p.imgUrl} style={{ height: 151 }} />
      </div>
      <VideoModal
        isOpen={open}
        onClose={() => setOpen(false)}
        src={p.exampleUrl}
        hideCloseButton={true}
        videoClassName="max-h-[600px] bg-black"
      />
    </div>
  );
};

export const NoVideos = ({
  dispatch,
  influencerId,
}: {
  dispatch: LibraryVM['dispatch'];
  influencerId: number;
}) => {
  const [showEducation, setShowEducation] = useState(true);
  return (
    <>
      <FlowEducationalModal
        isOpen={showEducation}
        onClose={() => setShowEducation(false)}
        source="library"
        influencerId={influencerId}
      />
      <article className={noVideosWrapper}>
        <div className={noVideosContent}>
          <Typography variant="headline" size="medium">
            Your media files will be shown here:
          </Typography>
          <div className={videoCardWrapper}>
            <VideoCard
              title="Clips"
              desc="Short, single-movement exercise clips. Under 60 sec, filmed in portrait mode."
              imgUrl={shortImage}
              onClick={() => dispatch('viewExample', { exampleType: 'Clip' })}
              exampleUrl="https://d1le80ixkppu39.cloudfront.net/library-clip-example.mp4"
            />
            <VideoCard
              title="Videos"
              desc="Files over 60 sec, good for workouts in both landscape and portrait. Ideal for guided workouts."
              imgUrl={longImage}
              onClick={() => dispatch('viewExample', { exampleType: 'Video' })}
              exampleUrl="https://d1le80ixkppu39.cloudfront.net/library-video-example.mp4"
            />
          </div>
          <Typography
            variant="body"
            size="large"
            className={sprinkles({ color: 'N-80' })}
          >
            At Playbook, we work with two types of video files: clips and
            videos. Different formats may suit various templates. Enjoy the
            flexibility
          </Typography>
          <Button
            leftIcon={faFileArrowUp}
            variant="filled"
            size="large"
            color="neutral"
            className="w-[180px]"
            onClick={() => dispatch('openUploadModal')}
            gap="m"
          >
            Upload
          </Button>
          <div className="flex flex-col gap-2 justify-center items-center">
            <Typography variant="body" size="medium">
              Learn how to use Library
            </Typography>
            <a
              href="https://help.playbookapp.io/en/articles/9486421-how-to-use-the-new-library"
              target="_blank"
              rel="noreferrer"
            >
              <Typography variant="body" size="large" color="P-80">
                Guide
              </Typography>
            </a>
          </div>
        </div>
      </article>
    </>
  );
};
